var APP_URL = "https://customizer.islideusa.com/designer/";
// //Start Name and number 
// //End Name and number 

// $(document).ready(function() {
//   var editCart = 0;
// //   getting cart settings from Imprint admin here
//   $.get(APP_URL + "api/v1/settings/carts", function(result) {
//     if(result){
//       var response = JSON.parse(result); 
//       if (response.is_enabled){
//         editCart = 1;
//          $(".design-edit-link").css("display", "block");
//       }  
//       }
//       });

// // Name number data
//   // Get the modal
  
//   $(".nnlink").each(function() {
//     var nnobj = $(this);
//      var ref_id = nnobj.attr('data-refid');
//     $.get(APP_URL + "api/v1/carts/isNameNum?design_id="+ref_id,function(data){
      
//       if(data.name_number){
//         nnobj.show();
//         console.log(data.name_number);
//       }
      
//     });
    
//   }); 
  
//   $(".nnlink").click(function() {
//     var nnobj = $(this);
//      var ref_id = nnobj.attr('data-refid');
//      var varId = nnobj.attr('data-varId');
//       $.get(APP_URL + "api/v1/carts/nameNumber?design_id="+ref_id+"&variant_id="+varId,function(data){
//           if(data!=undefined){
//             var tableContent = ' <span class="close">&times;</span><table><tr>';
//             $.each(data.fields,function(hKey, heading){
//               tableContent += "<th>"+heading+"</th>";
//             });
//             tableContent += "</tr>";
//             $.each(data.values,function(rKey, row){
//               tableContent += "<tr>";
//               $.each(row,function(cKey, content){
//                 tableContent += "<td>"+content+"</td>";
//               });
//               tableContent += "</tr>";
//             });
//             tableContent += "</table>";
//             $('.nnmodal-content').html(tableContent);
//             $("#nnModal").show();
//          }
//      });
//    }); 
// //   var modal = document.getElementById("nnModal");
// //   $(document).on('click','.close',function(){
// //     $("#nnModal").hide();
// //   });
 
// // var span = document.getElementsByClassName("close")[0];
// // span.onclick = function() {
// //   modal.style.display = "none";
// // }

// // When the user clicks anywhere outside of the modal, close it
// // window.onclick = function(event) {
// //   if (event.target == modal) {
// //     modal.style.display = "none";
// //   }
// // }
  
//    // Name number data
// //   image replace for customized items here
//   $(".ref-preview-img").each(function() {     
//     var obj = $(this);
//      var ref_id = obj.attr('data-ref-id');
//      var varId = obj.attr('data-varId');
//         var size = '';
//         var spid = '';
//       $.get(APP_URL + "api/v1/preview-images?custom_design_id="+ref_id+"&product_id="+varId,function(data){
//         if(ref_id!=undefined){
//             $.each(data,function(key, val){  
//               if(key==ref_id && val.length>0){                                   
//                  $.each(val,function(imgKey, imgObj){  
//                   var newElement = '<li  class="product-image product-thumb customize-image" title="">'+'<img src="'+imgObj['customImageUrl'][imgKey]+'" width="75" height="75" alt="" rel="'+ref_id+'" style="display:block;" class="previewimg">'+'</li>';
//                   //arr.push(newElement);
//                   $(obj).append(newElement);
//                    $(".loading").hide();
//                   // hide name and number info link
//                    if(imgObj['nameAndNumber'] == 0){
//                      jQuery(".nninfo_"+key).hide();
//                    }
//                  //show custom size in variable boundary.
//                  if(imgObj['variableDecorationSize'] != ''){
//                   $(obj).append('<li>custom '+imgObj['sizeAttr']+': '+ imgObj['variableDecorationSize'] + ' ' + imgObj['variableDecorationUnit'] +'</li>');
//                  }
//                 });
//               }
//             });
//       } 
//   });
// });
// // cart edit content here
  
//   $.getJSON('/cart.js', function(cartData) {
//       if(cartData){ 
//         var editURL = '';
//         var pid = thisPid = vid = dpid = qty = sku = cart_item_id = '';
//          $.each(cartData.items,function(key, item){
//            editURL = '';
//            pid = vid = dpid = qty = sku = cart_item_id = '';
//            thisPid = item.product_id;
//            vid = item.variant_id;
//            dpid = item.properties._refid;
//            qty = item.quantity;
//            cart_item_id = (key+1);
//            $.ajax({
//             async: false,
//             type: 'GET',
//             url: APP_URL + "api/v1/shopify-product/"+vid,
//             success: function(pdctID) {
//               pid = pdctID;
//              editURL = '/pages/designer-studio?id='+pid+'&vid='+vid+'&dpid='+dpid+'&qty='+qty+'&cart_item_id='+cart_item_id;
//              var itemKey = item.key;
//              var selector = itemKey.replace(":", "\\:")
//              $('#'+selector).attr("href", editURL);
//             }
//           });
           
//          });
//       }
// } );
  
 
// });

// /*
// Utility function to allow for simple query string lookups
// */
// function queryString()
// {
//    // This function is anonymous, is executed immediately and 
//   // the return value is assigned to QueryString!
//   var query_string = {};
//   var query = window.location.search.substring(1);
//   var varss = query.split("&");
//     var vars = varss[1].split("--");
    
  
//   for (var i=0;i<vars.length;i++) {
//     var pair = vars[i].split("=");
//         // If first entry with this name
//     if (typeof query_string[pair[0]] === "undefined") {
//       query_string[pair[0]] = decodeURIComponent(pair[1]);
//         // If second entry with this name
//     } else if (typeof query_string[pair[0]] === "string") {
//       var arr = [ query_string[pair[0]],decodeURIComponent(pair[1]) ];
//       query_string[pair[0]] = arr;
//         // If third or later entry with this name
//     } else {
//       query_string[pair[0]].push(decodeURIComponent(pair[1]));
//     }
//   } 
  
//   return query_string;
// }



// function addItem()
// {
//     var query_string = {};
//   var query = window.location.search.substring(1);
//   var vars = query.split("&");
// //   var url = new URL(url_string);
// //   var c = url.searchParams.get("c");
  

//    // var vars = varss[1].split("--");

   
//    for (var i=0;i<vars.length;i++) {
//     var pair = vars[i].split("=");
//          // If first entry with this name
//     if (typeof query_string[pair[0]] === "undefined") {
//       query_string[pair[0]] = decodeURIComponent(pair[1]);
//         // If second entry with this name
//     } else if (typeof query_string[pair[0]] === "string") {
//       var arr = [ query_string[pair[0]],decodeURIComponent(pair[1]) ];
//       query_string[pair[0]] = arr;
//         // If third or later entry with this name
//     } else {
//       query_string[pair[0]].push(decodeURIComponent(pair[1]));
//     }
//    }
  
      
//     //  
//     if(query_string.edit && query_string.edit != ""){
//       var deleteItem = query_string.edit; 
//       CartJS.removeItem(deleteItem);
//     }
//       /* Ref URL Parts
//           0: Imprint design ref ID
//           1: shopify variant id
//           2: quantity ordered     
//       */
//         //get potential of multiple items
//         var items = query_string.ref.split('--');
//       var itemNum = (items.length)-1;
//       //console.log(itemNum);
//       var waiting = 3000;
//          if(itemNum > 4){
//                     waiting = (itemNum/2)*3000;
//                   }

//        // alert(Querys.ref.split('--'));
//          // return false ;
     
      
//           //loop through items
             
            
//            for(var i in items)
//             {    
//                var this_item =items[i].split('-');
//                //console.log(this_item[1],this_item[2],this_item[0]);
              
//                 //add the item
//                    CartJS.addItem(this_item[1],this_item[2], { '_refid': this_item[0] }, {

//                 // Define a success callback to display a success message.
//                 "success": function(data, textStatus, jqXHR) {
//                     $('#info').addClass('message-success');
//                     $('#info').html('Loading.....Please Wait.');
                 
//                   if(i == itemNum){
//                     setTimeout(function() { window.location.href = '/cart';}, waiting);
                                         
//                   }
                  
//                 },

//                 // Define an error callback to display an error message.
//                 "error": function(jqXHR, textStatus, errorThrown) {
                  
//                     $('#info').addClass('message-error');
//                    $('#info').html('Preparing your shopping cart! <br><p style="color:black;"> Please wait.<p>');
//                    setTimeout(function(){
//                       location.reload();
//                   },2000)
//                 }
//             });  
//          }
// }

// function ref_add_to_cart()
// {
//   alert(typeof qsLookup.ref);
  
//     if(typeof qsLookup.ref != "undefined")
//   {
//       /* Ref URL Parts
//           0: riaxe design ref ID
//           1: shopify variant id
//           2: quantity ordered     
//       */
    
//         //get potential of multiple items
//         var this_item,items = qsLookup.ref.split('--');
      
//         //loop through items
//         for(var i in items)
//         {        
//           //unpack item
//           this_item = items[i].split('-');
      
//       //TODO: validate item
        
//           //add the item
//           $.ajax({
//             type: "POST",
//             url: '/cart/add.js',
//             data: {
//               quantity: this_item[2],
//               id: this_item[1],
//         async: false,
//               properties: {
//                 '_refid': this_item[0]
//               }
//             },
//             dataType: "json",
//             success: function(resp)
//             {
//               $("#info").html("Item Added!");
//             }
//           });
//         }      
      
//      window.location.href = '/cart';
//     }
//     else
//     {
//       //TODO: error handling 
//       $("#info").html("Error!");
//     }
// }



